module.exports = __webpack_public_path__ + "img/29.b18c2f71.png";